// src/firebase.config.ts
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Config Firebase
const firebaseConfig = {
  apiKey: "AIzaSyC8YgUCS8A6FeHXPocKIQCKzrl1zzMkGB4",
  authDomain: "traffic-ligths-game.firebaseapp.com",
  databaseURL: "https://traffic-ligths-game-default-rtdb.firebaseio.com",
  projectId: "traffic-ligths-game",
  storageBucket: "traffic-ligths-game.firebasestorage.app",
  messagingSenderId: "365086368348",
  appId: "1:365086368348:web:e1d39d3b351b913aa23c99",
  measurementId: "G-73PXXPXK71",
};

export const app = initializeApp(firebaseConfig); // ← exportado

export const database = getDatabase(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");